export enum BackgroundColor {
  Transparent = 'Transparent (No Background)',

  N0 = 'N0 (Neutral 0)',
  N1 = 'N1 (Neutral 1)',
  N10 = 'N10 (Neutral 10)',
  N20 = 'N20 (Neutral 20)',
  N30 = 'N30 (Neutral 30)',
  N40 = 'N40 (Neutral 40)',
  N50 = 'N50 (Neutral 50)',
  N60 = 'N60 (Neutral 60)',
  N70 = 'N70 (Neutral 70)',
  N80 = 'N80 (Neutral 80)',
  N90 = 'N90 (Neutral 90)',
  N100 = 'N100 (Neutral 100)',

  G1 = 'G1 (Green 1)',
  G10 = 'G10 (Green 10)',
  G20 = 'G20 (Green 20)',
  G30 = 'G30 (Green 30)',
  G40 = 'G40 (Green 40)',
  G50 = 'G50 (Green 50)',
  G60 = 'G60 (Green 60)',
  G70 = 'G70 (Green 70)',
  G80 = 'G80 (Green 80)',
  G90 = 'G90 (Green 90)',
  G100 = 'G100 (Green 100)',

  B1 = 'B1 (Blue 1)',
  B10 = 'B10 (Blue 10)',
  B20 = 'B20 (Blue 20)',
  B30 = 'B30 (Blue 30)',
  B40 = 'B40 (Blue 40)',
  B50 = 'B50 (Blue 50)',
  B60 = 'B60 (Blue 60)',
  B70 = 'B70 (Blue 70)',
  B80 = 'B80 (Blue 80)',
  B1001 = 'B1001 (Blue 1001)',

  C1 = 'C1 (Coral 1)',
  C10 = 'C10 (Coral 10)',
  C30 = 'C30 (Coral 30)',
  C40 = 'C40 (Coral 40)',
  C50 = 'C50 (Coral 50)',
  C60 = 'C60 (Coral 60)',

  YB1 = 'YB1 (Yellow 1)',
  YB10 = 'YB10 (Yellow 10)',
  YB20 = 'YB20 (Yellow 20)',
  YB30 = 'YB30 (Yellow 30)',
  YB40 = 'YB40 (Yellow 40)',
  YB50 = 'YB50 (Yellow 50)',

  I1 = 'I1 (Indigo 1)',
  I10 = 'I10 (Indigo 10)',
  I20 = 'I20 (Indigo 20)',
  I30 = 'I30 (Indigo 30)',
  I40 = 'I40 (Indigo 40)',
  I50 = 'I50 (Indigo 50)',
  I60 = 'I60 (Indigo 60)',
  I70 = 'I70 (Indigo 70)',
  I80 = 'I80 (Indigo 80)',

  S1 = 'S1 (Sky 1)',
  S10 = 'S10 (Sky 10)',
  S20 = 'S20 (Sky 20)',
  S30 = 'S30 (Sky 30)',
  S40 = 'S40 (Sky 40)',
  S50 = 'S50 (Sky 50)',
  S60 = 'S60 (Sky 60)',
  S70 = 'S70 (Sky 70)',
  S80 = 'S80 (Sky 80)',

  M1 = 'M1 (Magenta 1)',
  M10 = 'M10 (Magenta 10)',
  M30 = 'M30 (Magenta 30)',
  M40 = 'M40 (Magenta 40)',
  M60 = 'M60 (Magenta 60)',
  M70 = 'M70 (Magenta 70)',

  L1 = 'L1 (Lime 1)',
  L10 = 'L10 (Lime 10)',
  L20 = 'L20 (Lime 20)',
  L30 = 'L30 (Lime 30)',
  L40 = 'L40 (Lime 40)',
  L50 = 'L50 (Lime 50)',

  W0_24 = 'W0_24 (White 0)',

  N0_24 = 'N0_24 (Neutral 0)',
  N100_24 = 'N100_24 (Neutral 100)',

  G60_24 = 'G60_24 (Green 60)',
  G100_24 = 'G100_24 (Green 100)',

  O1001_24 = 'O1001_24 (Orange 1001)',
  O1002_24 = 'O1002_24 (Orange 1002)',

  B80_24 = 'B80_24 (Blue 80)',
  B1001_24 = 'B1001_24 (Blue 10001)',

  BT1001_24 = 'BT1001_24 (Blue Teal 1001)',

  P90_24 = 'P90_24 (Purple 90)',
  P100_24 = 'P100_24 (Purple 100)',

  T90_24 = 'T90_24 (Teal 90)',
}

export interface Background {
  color?: BackgroundColor
}
